// @flow
import React, { type Node } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import './TrendingSection.scss';

type Props = {
  children: Node,
  title: string,
  description?: string,
  color: string,
  more?: string,
};

const TrendingSection = ({ children, title, description, color, more }: Props) => (
  <div
    className={cx('TrendingSection')}
    style={{
      backgroundColor: color,
    }}
  >
    {title &&
      <div className="wrapper">
        <div className="content">
          {title && <span className="title">{title}</span>}<br />
          {description && <div className="description">{description}</div>}
        </div>
        {more &&
          <Link className="more" to={more}>더보기</Link>
        }
      </div>
    }
    <div className="contents">{children}</div>
  </div>
);

export default TrendingSection;



// WEBPACK FOOTER //
// ./src/components/trending/TrendingSection/TrendingSection.js